///Create Disbursement old
import React, { useEffect, useState, useContext, useMemo } from "react";
//Dialog
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Typography,
  Stack,
  Box,
  Button,
  TextField,
  Grid,
  Avatar,
  IconButton,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
//date picker
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
//Icons
import { LuSave } from "react-icons/lu";
import { BiMinusCircle } from "react-icons/bi";
import { IoAddCircleOutline } from "react-icons/io5";
//Srcs
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import ListAccountType from "./ListAccountType";
import {
  GET_DISBURSEMENT_BY_ID,
  UPDATE_DISBURSEMENT,
} from "../../Schema/Disbursement";

export default function CreateDisbursementDetails({
  open,
  handleClose,
  disbursementId,
}) {
  // Change Language
  const { language, setAlert } = useContext(AuthContext);
  const { t } = translateLauguage(language);

  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [requiredField, setRequiredField] = useState(false);

  const [date, setDate] = useState(new Date());
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_DISBURSEMENT_BY_ID, {
    variables: {
      id: disbursementId,
    },
    onCompleted: ({ getDisbursementId }) => {
      // console.log("getDisbursementId==>", getDisbursementId);
      setTableData(getDisbursementId);
      setLoading(false);

      if (getDisbursementId?.disbursements?.length !== 0) {
        let itemFromBackend = [];
        getDisbursementId?.disbursements?.map((d, index) => {
          let itemExpenseFromBackend = [];
          d?.items?.map((e, itemIndex) => {
            // console.log("e==>", e);
            let itemPaymentsFromBackend = [];
            if (e?.payments !== null) {
              e?.payments?.map((i, paymentIndex) => {
                const allPayments = {
                  subKey: "item" + itemIndex + 1 + Date.now(),
                  paymentDate: i?.paymentDate,
                  paymentMethod: i?.paymentMethod,
                  pricePaidKHR: i?.pricePaidKHR,
                  pricePaidUSD: i?.pricePaidUSD,
                  key: "payments" + paymentIndex + 1 + Date.now(),
                };
                itemPaymentsFromBackend?.push(allPayments);
              });
            }

            const allExpenseFromBackend = {
              mainKey: index + Date.now(),
              invDate: e?.invDate,
              invNo: e?.invNo,
              description: e?.description,
              supplierId: e?.supplierId,
              supplierName: e?.supplierName,
              qty: e?.qty,
              exchangeRate: e?.exchangeRate,
              priceKHR: e?.priceKHR,
              priceUSD: e?.priceUSD,
              key: "item" + itemIndex + 1 + Date.now(),
              itemUniqueId: e?.itemUniqueId,
              payments: e?.payments === null ? [] : itemPaymentsFromBackend,
            };

            if (d?.uniqueId === e?.itemUniqueId) {
              itemExpenseFromBackend?.push(allExpenseFromBackend);
            }
          });
          // console.log("d::", d);

          const allItemFromBackend = {
            accountTypeId: d?.accountTypeId,
            accountTypeName: d?.code_account + " - " + d?.accountType,
            items: itemExpenseFromBackend,
            key: index + Date.now(),
            uniqueId: d?.uniqueId,
          };
          itemFromBackend?.push(allItemFromBackend);
        });
        setDisbursementList([...itemFromBackend]);
      }

      // if (getDisbursementId?.disbursements?.length !== 0) {
      //   let itemFromBackend = [];
      //   getDisbursementId?.disbursements?.map((d, index) => {
      //     let itemExpenseFromBackend = [];
      //     d?.items?.map((e, subIndex) => {
      //       // console.log("e==>", e);
      //       const allExpenseFromBackend = {
      //         mainKey: "",
      //         invDate: e?.invDate,
      //         invNo: e?.invNo,
      //         description: e?.description,
      //         supplierId: e?.supplierId,
      //         supplierName: e?.supplierName,
      //         qty: e?.qty,
      //         exchangeRate: e?.exchangeRate,
      //         priceKHR: e?.priceKHR,
      //         priceUSD: e?.priceUSD,
      //         key: subIndex + Date.now(),
      //         itemUniqueId: e?.itemUniqueId,
      //       };

      //       if (d?.uniqueId === e?.itemUniqueId) {
      //         itemExpenseFromBackend?.push(allExpenseFromBackend);
      //       }
      //     });
      //     // console.log("d::", d);

      //     const allItemFromBackend = {
      //       accountTypeId: d?.accountTypeId,
      //       accountTypeName: d?.code_account + " - " + d?.accountType,
      //       items: itemExpenseFromBackend,
      //       key: index + Date.now(),
      //       uniqueId: d?.uniqueId,
      //     };
      //     itemFromBackend?.push(allItemFromBackend);
      //   });
      //   setDisbursementList([...itemFromBackend]);
      // }
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [open]);

  const [updateDisbursement] = useMutation(UPDATE_DISBURSEMENT, {
    onCompleted: ({ updateDisbursement }) => {
      setSubmitLoading(false);
      // console.log("updateDisbursement::", updateDisbursement);
      if (updateDisbursement?.status === true) {
        setAlert(true, "success", updateDisbursement?.message);
        handleClose();
        refetch();
      } else {
        setAlert(true, "error", updateDisbursement?.message);
      }
    },
    onError: (error) => {
      setSubmitLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  //============================ Start disbursementList ===============================
  const [currentDisbursement, setcurrentDisbursement] = useState({
    accountTypeId: "",
    accountTypeName: "",
    key: "",
    items: [
      {
        mainKey: "",
        invDate: "",
        invNo: "",
        description: "",
        supplierId: "",
        supplierName: "",
        qty: 0,
        exchangeRate: 0,
        priceKHR: 0,
        priceUSD: 0,
        key: "",
        payments: [],
      },
    ],
  });
  const [disbursementList, setDisbursementList] = useState([]);

  // console.log("disbursementList::", disbursementList);

  const addDisbursements = () => {
    let newDisbursement = currentDisbursement;
    if (newDisbursement !== 0) {
      const items = [...disbursementList, newDisbursement];
      setDisbursementList([...items]);
      setcurrentDisbursement({
        accountTypeId: "",
        accountTypeName: "",
        key: "",
        items: [
          {
            mainKey: "",
            invDate: "",
            invNo: "",
            description: "",
            supplierId: "",
            supplierName: "",
            qty: 0,
            exchangeRate: 0,
            priceKHR: 0,
            priceUSD: 0,
            key: "",
            payments: [],
          },
        ],
      });
    }
  };

  const handleAddDisbursement = () => {
    setcurrentDisbursement({
      accountTypeId: "",
      accountTypeName: "",
      key: Date.now(),
      items: [
        {
          mainKey: "",
          invDate: moment(),
          invNo: "",
          description: "",
          supplierId: "",
          supplierName: "",
          qty: 0,
          exchangeRate: 0,
          priceKHR: 0,
          priceUSD: 0,
          key: Date.now() + 12,
          payments: [],
        },
      ],
    });
  };

  useEffect(() => {
    if (currentDisbursement?.key !== "") {
      addDisbursements();
    }
  }, [currentDisbursement]);

  const deleteDisbursementList = (key) => {
    let filterDisbursementList = disbursementList?.filter(
      (t) => t?.key !== key
    );
    setDisbursementList(filterDisbursementList);
  };

  const setUpdateAccountType = (id, title, key) => {
    let items = disbursementList;
    items?.map((i) => {
      if (i.key === key) {
        i.accountTypeId = id;
        i.accountTypeName = title;
      }

      if (id !== "" || id !== undefined || id !== null) {
        setRequiredField(false);
      } else {
        setRequiredField(true);
      }
    });
    setDisbursementList([...items]);
  };

  const setUpdateExpenseItem = (list, key) => {
    // console.log("list", list, key);
    let listArr = [];
    list?.map((e) => {
      const allListItem = {
        mainKey: e?.mainKey,
        invDate: e?.invDate,
        invNo: e?.invNo,
        description: e?.description,
        supplierId: e?.supplierId,
        supplierName: e?.supplierName,
        qty: e?.qty,
        exchangeRate: e?.exchangeRate,
        priceKHR: e?.priceKHR,
        priceUSD: e?.priceUSD,
      };
      listArr?.push(allListItem);
    });

    const newItems = disbursementList;
    newItems?.map((i) => {
      if (i.key === key) {
        i.items = listArr;
      }
    });
    setDisbursementList([...newItems]);
  };

  const handleSubmit = () => {
    let createStatus = false;
    const BreakException = {};
    try {
      if (disbursementList?.length !== 0) {
        disbursementList?.forEach(function (elem) {
          if (
            elem?.accountTypeId !== undefined &&
            elem?.accountTypeId !== ""
            // &&
            // elem?.supplierId !== undefined &&
            // elem?.supplierId !== "" &&
            // elem?.qty !== undefined &&
            // elem?.qty !== 0 &&
            // elem?.qty !== "" &&
            // elem?.priceInKHR !== undefined &&
            // elem?.priceInKHR !== "" &&
            // elem?.priceInUSD !== undefined &&
            // elem?.priceInUSD !== ""
          ) {
            createStatus = true;
          } else {
            setSubmitLoading(false);
            setRequiredField(true);
            createStatus = false;
            throw BreakException;
          }
        });
      } else {
        setSubmitLoading(false);
        setRequiredField(true);
      }
    } catch (e) {
      if (e !== BreakException) throw e;
    }

    // console.log("asdfasdf::", submitLoading)

    if (createStatus) {
      // console.log("first", disbursementList);
      // let itemToSubmit = [];
      // disbursementList?.map((d) => {
      //   let itemExpense = [];
      //   d?.items?.map((e) => {
      //     const allExpenseData = {
      //       invDate: moment(e?.invDate).format("YYYY-MM-DD"),
      //       invNo: e?.invNo,
      //       description: e?.description,
      //       supplierId: e?.supplierId,
      //       qty: e?.qty,
      //       exchangeRate: e?.exchangeRate,
      //       priceKHR: e?.priceKHR,
      //       priceUSD: e?.priceUSD,
      //     };
      //     if (d?.key === e?.mainKey || d?.uniqueId === e?.itemUniqueId) {
      //       itemExpense?.push(allExpenseData);
      //     }
      //   });
      //   const allItemToSubmit = {
      //     accountType: d?.accountTypeId,
      //     items: itemExpense,
      //   };
      //   itemToSubmit?.push(allItemToSubmit);
      // });
      let itemToSubmit = [];
      disbursementList?.map((d) => {
        let itemExpense = [];
        d?.items?.map((e) => {
          let itemPayments = [];
          e?.payments?.map((p) => {
            const allPayments = {
              paymentDate: moment(p?.paymentDate).format("YYYY-MM-DD"),
              paymentMethod: p?.paymentMethod,
              pricePaidKHR: p?.pricePaidKHR,
              pricePaidUSD: p?.pricePaidUSD,
            };
            if (e?.key === p?.subKey) {
              itemPayments?.push(allPayments);
            }
          });

          const allExpenseData = {
            invDate: moment(e?.invDate).format("YYYY-MM-DD"),
            invNo: e?.invNo,
            description: e?.description,
            supplierId: e?.supplierId,
            qty: e?.qty,
            exchangeRate: e?.exchangeRate,
            priceKHR: e?.priceKHR,
            priceUSD: e?.priceUSD,
            payments: itemPayments,
          };

          if (d?.key === e?.mainKey || d?.uniqueId === e?.itemUniqueId) {
            itemExpense?.push(allExpenseData);
          }
        });
        const allItemToSubmit = {
          accountType: d?.accountTypeId,
          items: itemExpense,
        };
        itemToSubmit?.push(allItemToSubmit);
      });
      
      // console.log("itemToSubmit::",disbursementId, itemToSubmit);
      setSubmitLoading(true);
      updateDisbursement({
        variables: {
          id: disbursementId,
          input: itemToSubmit,
        },
      });
    }
  };

  return (
    <Dialog open={open} className="dialog-container" fullWidth fullScreen>
      <DialogTitle sx={{ padding: "10px 20px" }}>
        <Stack direction="row" spacing={2}>
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              Create disbursement list
            </Typography>
          </Stack>
          <Box sx={{ flexGrow: 1 }} />
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container rowSpacing={1} columnSpacing={3}>
          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="select-title">{t("thead_date")}</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={date}
                inputFormat="dd-MM-yyyy"
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
            <Typography className="select-title">Last save at</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
                value={tableData?.lastSave}
                inputFormat="dd-MM-yyyy hh:mm a"
                renderInput={(params) => (
                  <TextField {...params} size="small" fullWidth />
                )}
              />
            </LocalizationProvider>
          </Grid>

          {tableData?.updatedBy ? (
            <Grid item xs={6} sm={6} md={3} lg={3} xl={2.4}>
              <Typography className="select-title">Last update by</Typography>
              <Stack className="update-by" direction="row" spacing={1}>
                <Avatar
                  src={tableData?.updatedBysrc}
                  alt={tableData?.updatedBy}
                  sx={{ width: "38px", height: "38px", marginTop: "2px" }}
                />
                <Stack direction="column" justifyContent="center">
                  <Typography className="name">
                    {tableData?.updatedBy}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          ) : null}

          <Box flexGrow={1} />

          <Grid item xs={6} sm={6} md={3} lg={3} xl={4.8}>
            <Stack direction="row" justifyContent="right">
              {submitLoading ? (
                <Button
                  className="btn-save"
                  startIcon={<LuSave alt="CreateIcon" className="icon-add" />}
                >
                  {t("loading")}
                </Button>
              ) : (
                <Button
                  onClick={handleSubmit}
                  className="btn-save"
                  startIcon={<LuSave alt="CreateIcon" className="icon-add" />}
                >
                  {t("save")}
                </Button>
              )}
            </Stack>
          </Grid>
        </Grid>

        <Box sx={{ marginTop: "10px" }}>
          <Grid container rowSpacing={2} spacing={2}>
            <Grid item xs={12}>
              <Stack
                sx={{
                  borderBottom: "1px solid #0f81c2",
                  width: "100%",
                }}
                direction="row"
                justifyContent="space-between"
              >
                <Stack direction="column" justifyContent="center">
                  <Typography className="field-title-kh">
                    ប្រភេទចំណាយ
                  </Typography>
                </Stack>
                <IconButton onClick={handleAddDisbursement}>
                  <IoAddCircleOutline className="close-icon" />
                </IconButton>
              </Stack>
            </Grid>

            <Grid item xs={12}>
              <ListAccountType
                setUpdateExpenseItem={setUpdateExpenseItem}
                requiredField={requiredField}
                disbursementList={disbursementList}
                setDisbursementList={setDisbursementList}
                deleteDisbursementList={deleteDisbursementList}
                setUpdateAccountType={setUpdateAccountType}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
